import { ActivityEntityName, WorkOrder } from '@jms/model';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';
import { JobRelationName } from '../work.job/job.relation.names';

/**
 * Stage (WorkOrder) capabilities for composition inside Job Manage.
 *
 * No routes, operations, or surfaces: Stage is not a standalone entity page.
 * Open and edit Stages only through Job Manage scope.
 */
export const workOrderManifest = registerManifest<WorkOrder>({
  entity: ActivityEntityName.WorkOrder,
  slug: 'stage',
  board: {
    bulkActionHandlers: {
      'activity.note.create': () => import('./bulk.actions/stage.activity.note.bulk.action').then(m => m.handleStageActivityNoteBulkAction),
      'claim.process': () => import('./bulk.actions/stage.claim.bulk.action').then(m => m.handleStageClaimBulkAction),
      'status.change': () => import('./bulk.actions/stage.status.bulk.action').then(m => m.handleStageStatusBulkAction),
    },
  },
  relations: {
    [JobRelationName.Items]: () => import('./relations/work.order.items.relation').then(m => m.workOrderItemsBoardBuilder),
    [JobRelationName.Sor]: () => import('./relations/work.order.sor.relation').then(m => m.workOrderSorBoardBuilder),
    [JobRelationName.Tasks]: () => import('./relations/work.order.tasks.relation').then(m => m.workOrderTasksBoardBuilder),
    [JobRelationName.Bills]: () => import('./relations/work.order.bills.relation').then(m => m.workOrderBillsBoardBuilder),
    [ActivityEntityName.File]: () => import('./relations/work.order.files.relation').then(m => m.workOrderFilesBoardBuilder),
    [ActivityEntityName.Activity]: () => import('./relations/work.order.activities.relation').then(m => m.workOrderActivitiesBoardBuilder),
  },
});
